module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-7.890ec5c4.JPG";